import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './styles/App.css';
import './styles/cursor.css';
import LocomotiveScroll from 'locomotive-scroll';
import 'locomotive-scroll/src/locomotive-scroll.scss';
import Home from './components/Home2';
import Projects from './components/Projects';
import About from './components/About';
import Navbar from './components/Navbar';
import LoveButton from './components/LoveButton';
import Resume from './components/Resume';
import Cursor from './components/Cursor';
// import Hobby from './components/Hobby';


function App() {
  const scrollRef = useRef(null);
  const location = useLocation();
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const scroll = new LocomotiveScroll({
      el: scrollRef.current,
      smooth: true,
      lerp: 0.1,
      smartphone: {
        smooth: true,
        lerp: 0.1,
      },
    });

    return () => {
      if (scroll) scroll.destroy();
    };
  }, []);

  const handleThemeChange = () => {
    setIsDark(!isDark);
  };

  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-theme");
      document.body.classList.remove("light-theme");
    } else {
      document.body.classList.add("light-theme");
      document.body.classList.remove("dark-theme");
    }
  }, [isDark]);

  return (
    <div className="app" ref={scrollRef}>
      <Cursor />
      <Navbar isDark={isDark} handleThemeChange={handleThemeChange} />
      <LoveButton size={50} loveCount={2560} />
      <Routes key={location.key} location={location}>
        <Route exact path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
        {/* <Route path="/hobbies" element={<Hobby />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
